module.exports = __webpack_public_path__ + "img/ban-bug.83e27659.svg";